
import React from "react";

interface SummaryItem {
  icon: React.ReactNode;
  label: string;
  value: string;
}

interface StepItem {
  id: number;
  title: string;
  icon: React.ReactNode;
}

interface RfqSummaryProps {
  completion: number;
  summaryItems: SummaryItem[];
  currentStep: number;
  steps: StepItem[];
}

export default function RfqSummary({
  completion,
  summaryItems,
  currentStep,
  steps,
}: RfqSummaryProps) {
  return (
    <div className="summary-card">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="summary-title mb-0">Aperçu de la demande</div>
        <span className="summary-badge">{completion}% rempli</span>
      </div>

      <div className="summary-list">
        {summaryItems.map((item) => (
          <div className="summary-item" key={item.label}>
            <div className="summary-item-icon">{item.icon}</div>
            <div>
              <span className="summary-label">{item.label}</span>
              <span className="summary-value">{item.value}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="summary-stage mt-3">
        <span className="summary-stage-label">Étape actuelle</span>
        <span className="summary-stage-value">{steps[currentStep - 1].title}</span>
      </div>
    </div>
  );
}
